import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=1303dfb7&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=ts&"
export * from "./Content.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=1303dfb7&prod&lang=scss&scoped=true&"
import style1 from "./Content.vue?vue&type=style&index=1&id=1303dfb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1303dfb7",
  null
  
)

export default component.exports